"use strict";

import "whatwg-fetch";

import { optionsGen } from "@/helpers/api";
import { API_URL } from "@/config";
import { toESQuery, toESGroupByQuery, toESDateHistogramQuery, toESDateHistogramGroupByQuery } from "@/helpers/query";
import { toTitleCase } from "@/helpers/converters";

const AUTH = false;
export const UPC_URL = `${API_URL}/cases/upc_new`;
export const UPC_SEARCH_URL = `${API_URL}/cases/upc_new/_search`;

export function getUPCCaseDetail(casenum) {
  return fetch(`${UPC_URL}/${encodeURIComponent(casenum)}`, optionsGen("GET", false, AUTH)).then(resp => resp.json());
}

export function esqUPCCases(query, highlight = false) {
  return toESQuery(query, ["documents"], 20, highlight);
}

export function getUPCCases(query) {
  return fetch(UPC_SEARCH_URL, optionsGen("POST", esqUPCCases(query, true), AUTH))
    .then((resp) => resp.json())
    .then(json => { return json; });
}

export function getDistinctValues(field, val) {
  return fetch(UPC_SEARCH_URL, optionsGen("POST", toESGroupByQuery(field, {
    [field]: val
  })))
    .then(resp => resp.json())
    .then(json => json.aggregations[field].buckets.map(e => toTitleCase(e.key)));
}

export function countUPCCasesByDate(query, dateField, interval = "year") {
  let q = toESDateHistogramQuery(dateField, interval, query);
  return fetch(UPC_SEARCH_URL, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json => {
      return json.aggregations[dateField].buckets;
    });
}

export function countUPCCasesByField(query, field, size = 20) {
  return fetch(UPC_SEARCH_URL, optionsGen("POST", toESGroupByQuery(field, query, size), AUTH))
    .then(resp => resp.json())
    .then(json => {
      let total = json.aggregations[field].sum_other_doc_count;
      json.aggregations[field].buckets.forEach(b => {
        total += b.doc_count;
      });
      return json.aggregations[field].buckets.map(b => ({
        ...b,
        doc_pct: b.doc_count / total
      }));
    });
}

export function countUPCCasesByFieldWithThreshold(query, field, labelMap, mergeThreshold = 0.02) {
  return fetch(UPC_SEARCH_URL, optionsGen("POST", toESGroupByQuery(field, query, 50)))
    .then(resp => resp.json())
    .then(json => {
      const total = json.hits.total.value;
      let otherCount = json.aggregations[field].sum_other_doc_count || 0;
      let res = {};
      let keyCountPairs = json.aggregations[field].buckets;
      keyCountPairs.forEach(e => {
        const key = toTitleCase(e.key);
        const label = labelMap ? labelMap[key] || key : key;
        // put fractions less than `mergeThreshold` into `Other`
        if (e.doc_count / total >= mergeThreshold) {
          res[label] = e.doc_count;
        } else {
          otherCount += e.doc_count;
        }
      });
      if (otherCount > 0) {
        res.Other = otherCount;
      }
      return res;
    });
}

export function countUPCCasesByDateAndField(query, dateField, field2, interval = "year") {
  let q = toESDateHistogramGroupByQuery(dateField, field2, interval, query);
  return fetch(UPC_SEARCH_URL, optionsGen("POST", q, AUTH))
    .then(resp => resp.json())
    .then(json =>
      json.aggregations[dateField].buckets.map(b => ({
        key: b.key,
        key_as_string: b.key_as_string,
        value: b[field2].buckets.map(bb => ({
          key: bb.key,
          doc_count: bb.doc_count
        }))
      }))
    );
}